import { Component, OnInit} from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { Router } from '@angular/router';
import { AuthorizationService } from '../core/services/auth/auth.service';
import { CommonService } from '../core/services/common/common.service';
import { UserService } from '../core/services/user/user.service';
import { QuoteLiteService } from '../core/services/quote-lite/quote-lite.service';

@Component({
  selector: 'authorization',
  templateUrl: 'auth.component.html',
})
export class AuthorizationComponent
  implements OnInit
{
  groupId =
    localStorage.getItem('group_id') == null ||
    localStorage.getItem('group_id') == undefined
      ? 0
      : parseInt(localStorage.getItem('group_id'));
  constructor(
    private oauthService: OAuthService,
    private router: Router,
    private _authorizationService: AuthorizationService,
    private _commonService: CommonService,
    private _userService: UserService,
    private _quoteLiteService: QuoteLiteService
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnInit() {
    this.validateToken();
  }
 
  validateToken() {
    if (this.oauthService.hasValidAccessToken()) {
      this.groupId = this.groupId == -1 ? 0 : this.groupId;
      let isFromWBQuote = localStorage.getItem('IsFromWBQuote');
      if (
        localStorage.getItem('IsDirectUser') == 'Yes' &&
        (isFromWBQuote == undefined ||
          isFromWBQuote == '' ||
          isFromWBQuote == null)
      ) {
        if (this._authorizationService.userId != null)
          this.FetchBrokerAccounts(this._authorizationService.userId);
      } else {
        if (this.groupId > 0) {
          if (this._commonService.existingfinalQuoteId > 0) {
            let result: any = { QuoteId: 0, IsAnyFinalQuote: false };
            result.QuoteId = this._commonService.existingfinalQuoteId;
            result.IsAnyFinalQuote = !!this._commonService.existingIsAnyFinalQuote;
            this.getFinalQuoteSelection(result);
          } else {
            this._quoteLiteService.getFinalQuoteId(this.groupId).subscribe(
              (result: any) => {
                this.getFinalQuoteSelection(result);
              },
              (error) => {
                this._commonService.isAnyFinalQuote = false;
                this._commonService.isFinalQuoteChecked = true;
                this.router.navigateByUrl('/dashboard');
              });
          }
        } else {
          this._commonService.isFinalQuoteChecked = true;
          this._commonService.isAnyFinalQuote = false;
          this.router.navigateByUrl('/dashboard');
        }
      }
    }
  }

  private getFinalQuoteSelection(result: any) {
    if (result != null) {
      this._commonService.isAnyFinalQuote = result.IsAnyFinalQuote;
      this._commonService.finalQuoteId = result.QuoteId;
      if (result.IsAnyFinalQuote) {
        this._quoteLiteService
          .getFinalQuoteSelections(result.QuoteId)
          .subscribe((response) => {
            if (response != null) {
              this._commonService.finalQuoteSelections = response;
              this._commonService.isFinalQuoteChecked = true;
              this.router.navigateByUrl('/dashboard');
            }
          });
      } else {
        this._commonService.isFinalQuoteChecked = true;
        this.router.navigateByUrl('/dashboard');
      }
    } else {
      this._commonService.isFinalQuoteChecked = true;
      this.router.navigateByUrl('/dashboard');
    }
  }

  private FetchBrokerAccounts(userId: number) {
    this._userService.getUserInformation(userId).subscribe(
      (result) => {
        if (
          result != null &&
          result != undefined &&
          typeof result == 'object' &&
          result.Brokers != null &&
          result.Brokers.length > 0
        ) {
          let userInformation = result;
          let brokerAccount = userInformation.Brokers[0];
          if (brokerAccount != undefined) {
            localStorage.setItem('broker_id', brokerAccount.BrokerId);
            localStorage.setItem(
              'broker_state',
              brokerAccount.BrokerLicenses[0].StateId
            );
            localStorage.setItem('salesRepName', brokerAccount.SalesRepName);
            localStorage.setItem('salesRepEmail', brokerAccount.SalesRepEmail);
            localStorage.setItem(
              'broker_name',
              brokerAccount.FirstName + ' ' + brokerAccount.LastName
            );
            localStorage.setItem(
              'broker_LicenseNumber',
              brokerAccount.BrokerLicenses[0].LicenseNumber
            );
            localStorage.setItem('broker_Phone', brokerAccount.Phone);
            this.router.navigateByUrl('/dashboard');
          }
        }
      },
      (error) => {}
    );
  }
}
